/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/require-default-props */
import React from "react";

type TypographyProps = {
  varient?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body" | "caption";
  children?: React.ReactNode;
  className?: string;
  style?: object;
  onClick?: () => void;
  ref?: any;
};

export const Typography = (props: TypographyProps) => {
  if (!props) return <></>;

  const { varient, children, className, style, onClick, ref } = props;

  return (
    <p className={`${varient} ${className}`} style={style} onClick={onClick} ref={ref} {...props}>
      {children}
    </p>
  );
};

Typography.defaultProps = {
  varient: "body",
  children: "Paragraph text",
};
